import { render, staticRenderFns } from "./SSSListe.vue?vue&type=template&id=196a85b2&scoped=true&"
import script from "./SSSListe.vue?vue&type=script&lang=js&"
export * from "./SSSListe.vue?vue&type=script&lang=js&"
import style0 from "./SSSListe.vue?vue&type=style&index=0&id=196a85b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a85b2",
  null
  
)

export default component.exports